import { FaPlus } from "react-icons/fa";
import Card from "../atoms/Card";
import CardHeader from "../atoms/CardHeader";
import IconButton from "../atoms/IconButton";
import MantenimientoTable from "../organisms/mantenimiento/MantenimientoTable";
import useModal from "../../hooks/useModal";
import Modal from "../molecules/Modal";
import MantenimientoCreate from "../organisms/mantenimiento/MantenimientoCreate";
import { useEffect, useState } from "react";
import { GET_MANTENIMIENTO } from "../../api/apiMantenimiento";
import { GET_INMUEBLES } from "../../api/apiInmuebles";
import { PropagateLoader } from "react-spinners";
import { GET_USER_ROLE } from "../../api/apiUsers";
import Fuse from "fuse.js";
import moment from "moment";
import MantenimientoFilter from "../organisms/mantenimiento/MantenimientoFilter";
import { getInmobiliaria } from "../../utils/getInmobiliaria";
import { useSession } from "../../context/SessionContext";
import { PiMicrosoftExcelLogoFill } from "react-icons/pi";
import { exportMantenimientoToExcel } from "../../utils/excel/exportMantenimientoToExcel";
import Breadcrumb from "../molecules/Breadcrumb";

const MantenimientoTemplate = () => {
    const { user } = useSession();
    const [loading, setLoading] = useState();
    const [inmuebles, setInmuebles] = useState();
    const [staff, setStaff] = useState();
    const { open, isOpen, close } = useModal();
    const [mantenimiento, setMantenimiento] = useState();
    const [filteredMantenimiento, setFilteredMantenimiento] = useState();
    const [filters, setFilters] = useState({
        inmuebles: [], date_service: { start: "", end: "" }, description: "", staff: null,
    });

    useEffect(() => {
        const getInmuebles = async () => {
            try {
                setLoading(true);
                const inmueblesData = await GET_INMUEBLES();
                setInmuebles(inmueblesData);
            } catch (error) {
                console.error(error);
            } finally {
                setLoading(false);
            }
        };

        getInmuebles();
    }, []);

    useEffect(() => {
        const getStaff = async () => {
            try {
                setLoading(true);
                const staffData = await GET_USER_ROLE("Staff");
                setStaff(staffData);
            } catch (error) {
                console.error(error);
            } finally {
                setLoading(false);
            }
        };

        getStaff();
    }, []);

    const getMantenimiento = async () => {
        setLoading(true);

        try {
            const mantenimientoData = await GET_MANTENIMIENTO();
            setMantenimiento(mantenimientoData);
        } catch (error) {
            console.error(error);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        getMantenimiento();
    },[]);

    useEffect(() => {
        if (!mantenimiento) return;

        let result = [...mantenimiento];

        if (filters.date_service.start && filters.date_service.end) {
            result = result.filter(g => {
                const date = moment(g.date);
                return (
                    date.isSameOrAfter(moment(filters.date_service.start), "day") &&
                    date.isSameOrBefore(moment(filters.date_service.end), "day")
                );
            });
        }

        if (filters.inmuebles && filters.inmuebles.length > 0) {
            result = result.filter(gasto =>
                filters.inmuebles.includes(gasto.propertieId)
            );
        }

        if (filters.staff) {
            result = result.filter(item => item.staffId === filters.staff);
        }

        if (filters.description) {
            const fuse = new Fuse(result, {
                keys: ["description"],
                threshold: 0.3,
                ignoreLocation: true,
            });
            result = fuse.search(filters.description).map(res => res.item);
        }

        setFilteredMantenimiento(result);
    }, [filters, mantenimiento]);

    if (loading) { return ( <div className="w-full flex justify-center items-center py-10"> <PropagateLoader color="red" /> </div> ); }

    const options = inmuebles?.map(im => ({
        value: im.id,
        label: `${im?.name} - ${getInmobiliaria(im.real_estate)}`,
    }));

    const optionsStaff = staff?.map(s => ({ value: s.id, label: s?.name, }));

    return (
        <div className="flex flex-col gap-4">
            <CardHeader
                left={
                    <Breadcrumb
                        items={[
                            { label: "Inicio", to: "/inicio" },
                            { label: "Mantenimiento", to: null },
                        ]}
                    />
                }
                right={
                    <div className="flex flex-row gap-2">
                        <IconButton
                            icon={PiMicrosoftExcelLogoFill}
                            bgColor="bg-green-600" iconColor="text-white"
                            onClick={() => exportMantenimientoToExcel(filteredMantenimiento, inmuebles, staff)}
                        />
                        <IconButton
                            icon={FaPlus}
                            bgColor={`${user?.role === "Staff" ? "bg-white" : "bg-green-600"}`}
                            onClick={open}
                            disabled={user?.role === "Staff"}
                        />
                    </div>
                }
            />
            <Card>
                <MantenimientoFilter filters={filters} setFilters={setFilters} options={options} optionsStaff={optionsStaff}/>
                <MantenimientoTable data={filteredMantenimiento} loading={loading} inmuebles={inmuebles} staff={staff} refetch={getMantenimiento} />
            </Card>
            {isOpen &&
                <Modal title="Crear registro de mantenimiento" onClose={close} >
                    <MantenimientoCreate refetch={getMantenimiento} onClose={close} optionsStaff={optionsStaff} options={options} />
                </Modal>
            }
        </div>
    );
};

export default MantenimientoTemplate;